// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e89d2cfc","239":"6d7e7e09","455":"adfdcb4e","762":"9a58db7b"}[chunkId] + ".chunk.js";
};